import React from 'react';
import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';

type EosIconProps = {
  className?: string;
  sx?: SxProps<Theme>;
};

export function EosIcon({ className = '', sx }: EosIconProps) {
  return (
    <Box
      component="svg"
      className={className}
      sx={{
        display: 'inline-block',
        width: '1em',
        height: '1em',
        fontSize: 22,
        flexShrink: 0,
        overflow: 'visible',
        ...sx,
      }}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 8.5h6.5c1.2 0 1.8-.45 2.4-1.5l1.1-2c.55-1 1.25-1.5 2.45-1.5H20" />
      <path d="M4 12h16" />
      <path d="M4 15.5h6.5c1.2 0 1.8.45 2.4 1.5l1.1 2c.55 1 1.25 1.5 2.45 1.5H20" />
    </Box>
  );
}
